<!--
 * @Description: 分区管理
 * @Author: gao shuai
 * @Date: 2020-07-03 09:20:00
 * @LastEditTime: 2020-07-07 17:39:20
 * @LastEditors: gao shuai
-->
<template>
  <div class="partMange">
    <ul class="operContainer">
      <li>
        <span class="tit">所属分组：</span>
        <div class="inputbox">
          <slector title="所属分组" :columns="belongTeamdrow" :value.sync="belongTeam"></slector>
        </div>
      </li>
      <li>
        <span class="tit">游戏模板：</span>
        <div class="inputbox">
          <slector title="游戏模板" :columns="gameMoudledrow" :value.sync="gameMoudle"></slector>
        </div>
      </li>
    </ul>
    <div class="tabContainer">
      <van-tabs v-model="active" color="#16cd93" @change="handleClick">
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="传奇" name="1"></van-tab>
        <van-tab title="传世" name="2"></van-tab>
        <van-tab title="通用" name="4"></van-tab>
      </van-tabs>
    </div>
    <div class="operatBox clearfix">
      <span class="delete" @click="handleClose(selclist)">删除</span>
      <span class="rank" @click="sortArea">排序</span>
    </div>
    <div v-if="isloading">
      <van-pull-refresh v-if="list.length>0" class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
          <van-checkbox-group v-model="checklist">
            <ul class="listbox">
              <li v-for="(item,i) in list" :key="''+i">
                <span class="checkbox">
                  <van-checkbox :name="item.id" checked-color="#07c160"></van-checkbox>
                </span>
                <div class="container">
                  <p class="list">排序：
                    <span class="inp">
                      <input v-model="item.sort" type="number">
                    </span>
                  </p>
                  <p class="list">名称：{{item.name}}</p>
                  <p class="list">游戏币：{{item.currencyName}}</p>
                  <p class="list">服务器：<span style="color:#3485ff">{{item.serverIp}}</span></p>
                  <p class="list">路径： {{item.scriptPath}}</p>
                  <div class="btnbox">
                    <p @click="checklink(item.id)">检测</p>
                    <p @click="editarea(item.id)">编辑</p>
                    <p @click="loadingArea(item.id)">加载</p>
                    <p @click="areaClone(item.id)">克隆</p>
                    <p @click="toOrderreissue(item.id)">补发</p>
                    <p @click="handleClose([{id:item.id}])">删除</p>
                  </div>
                </div>
              </li>
            </ul>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else description="无内容" />
    </div>
  </div>
</template>

<script>
import slector from '../components/slector1';
export default {
  components: {
    slector
  },
  data() {
    return {
      isloading: false,
      active: '0',
      belongTeamdrow: [], // 所属分组下拉
      belongTeam: '', // 所属分组
      gameMoudledrow: [], // 游戏模板下拉
      gameMoudle: '', // 游戏模板
      list: [], // 列表数据
      checklist: [], // 多选列表
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 5,
      total: 0
    };
  },
  computed: {
    selclist: function() {
      return this.checklist.map((item) => {
        return {
          id: item
        };
      });
    }
  },
  watch: {
    checklist(n, o) {
      console.log(n, '5555');
    },
    belongTeam() {
      this.list = [];
      this.PageNumber = 1;
      this.getlist();
    },
    gameMoudle() {
      this.list = [];
      this.PageNumber = 1;
      this.getlist();
    }
  },
  methods: {
    // tab的切换
    handleClick() {
      this.isloading = false;
      this.PageNumber = 1;
      this.list = [];
      this.finished = false;
      this.getlist();
    },
    // 分区管理列表
    getlist() {
      this.$api.home
        .arealist({
          Type: this.active,
          GroupNameID: this.belongTeam === '' ? 0 : this.belongTeam,
          TemplatesID: this.gameMoudle === '' ? 0 : this.gameMoudle,
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          this.isloading = true;
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isloading = true;
          this.$toast(err.message);
        });
    },
    // 所属分组下拉
    belongDrow() {
      this.$api.home
        .belongDrow()
        .then((data) => {
          if (data.status === 200) {
            this.belongTeamdrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 游戏模板下拉
    gameDrow() {
      this.$api.home
        .gameDrow()
        .then((data) => {
          if (data.status === 200) {
            this.gameMoudledrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished) {
        return;
      }
      this.getlist();
    },
    // 多行删除
    sigleDelarea(selc) {
      this.$api.home
        .delAreas(selc)
        .then((data) => {
          if (data.status === 200) {
            this.$toast.success('删除成功');
            this.list = [];
            this.PageNumber = 1;
            this.finished = false;
            this.checklist = [];
            this.getlist();
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message);
        });
    },
    // 删除分组
    handleClose(selc) {
      if (selc.length === 0) {
        this.$toast.fail('请勾选删除项');
        return;
      }
      this.$dialog
        .confirm({
          message: '删除后数据无法恢复，是否确定？'
        })
        .then(() => {
          this.sigleDelarea(selc);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 排序
    sortArea() {
      if (this.selclist.length === 0) {
        this.$toast.fail('请勾选排序项');
        return;
      }
      let flag = true;
      let arr1 = this.selclist.map((item) => {
        let sel = this.list.filter((li) => {
          return li.id === item.id;
        })[0];
        if (sel.sort === '') {
          flag = false;
        } else {
          return {
            id: item.id,
            sort: sel.sort
          };
        }
      });
      if (flag) {
        this.$api.home
          .sortAreas(arr1)
          .then((data) => {
            if (data.status === 200) {
              this.$toast.success('排序成功！');
              this.list = [];
              this.PageNumber = 1;
              this.finished = false;
              this.checklist = [];
              this.getlist();
            }
          })
          .catch((err) => {
            this.$toast.fail(err.message);
          });
      } else {
        this.$toast.fail('排序不能为空！');
      }
    },
    // 编辑分区
    editarea(id) {
      this.$router.push({ path: '/installEdit', query: { id: id } });
    },
    // 分区检测
    checklink(id) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      });
      this.$api.home
        .checkLink({
          partitionId: id
        })
        .then((data) => {
          this.$toast.clear();
          if (data.status === 200) {
            this.$toast.success('检测成功');
          }
        })
        .catch(() => {
          this.$toast.clear();
          this.$toast.fail('检测失败');
        });
    },
    // 加载分区
    loadingArea(id) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      });
      this.$api.home
        .loadingArea({ id: id })
        .then((data) => {
          this.$toast.clear();
          if (data.status === 200) {
            this.$toast.success('加载成功');
          }
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast(err.message);
        });
    },
    // 补发订单
    toOrderreissue(id) {
      this.$router.push({ path: '/manualReissue', query: { id: id } });
    },
    // clone分区
    areaClone(id) {
      this.$router.push({ path: '/installClone', query: { id: id } });
    }
  },
  created() {
    this.belongDrow();
    this.gameDrow();
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.partMange {
  height: 100%;
  overflow-y: auto;
  .scrolldiv {
    min-height: calc(100% - 193px);
    background: #ededed;
  }
  .operContainer {
    padding: 20px 10px 10px;
    text-align: center;
    li {
      margin-bottom: 8px;
      .tit {
        display: inline-block;
        vertical-align: middle;
        color: #727272;
        font-size: 17px;
      }
      .inputbox {
        display: inline-block;
        vertical-align: middle;
        width: 160px;
      }
    }
  }
  .tabContainer {
    padding: 3px 0;
    border-top: 3px solid #ededed;
    border-bottom: 3px solid #ededed;
  }
  .operatBox {
    height: 30px;
    background: #fff;
    border-bottom: 3px solid #ededed;
    .rank {
      float: right;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      color: #3485ff;
      font-size: 11px;
      background: url(../assets/images/rank.png) no-repeat left center;
      background-size: 16px auto;
      margin-right: 20px;
    }
    .delete {
      float: right;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      color: #ff5050;
      font-size: 11px;
      background: url(../assets/images/delete.png) no-repeat left center;
      background-size: 14px auto;
      margin-right: 10px;
    }
  }
  .inp {
    display: inline-block;
    width: 50px;
    margin-right: 10px;
    background: #fff;
    border-radius: 4px;
    color: #b1b1b1;
    font-size: 14px;
    input {
      display: block;
      border: none;
      outline: none;
      width: 5px;
      height: 26px;
      padding: 0 10px;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #dbd8d8;
      &:focus {
        border-color: #1abc9c;
      }
    }
  }
  .listbox {
    li {
      position: relative;
      background: #fff;
      padding: 5px 10px 5px 45px;
      border-bottom: 3px solid #ededed;
      .checkbox {
        position: absolute;
        top: 30px;
        left: 10px;
      }
      .container {
        .list {
          font-size: 10px;
          color: #727272;
          margin-bottom: 1px;
        }
      }
      .btnbox {
        display: flex;
        flex-flow: row nowrap;
        margin-top: 8px;
        p {
          width: 18.33%;
          text-align: center;
          height: 30px;
          line-height: 30px;
          color: #fff;
          background: #16cd93;
          &:first-child {
            border-radius: 5px 0 0 5px;
          }
          &:last-child {
            background: red;
            border-radius: 0 5px 5px 0;
            &:after {
              display: none;
            }
          }
          &:after {
            content: '';
            float: right;
            height: 20px;
            width: 1px;
            background: #fff;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
